// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"00f23172","545":"00d542f6","787":"c87ed9c8"}[chunkId] + ".chunk.js";
};